import React from 'react';

import { Slot } from '@radix-ui/react-slot';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';

const TooltipWrapper = React.forwardRef<
  HTMLDivElement,
  { tooltip: string; children: React.ReactNode }
>((props, ref) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Slot {...props} ref={ref} />
        </TooltipTrigger>
        <TooltipContent asChild>
          <span>{props.tooltip}</span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
});

export default TooltipWrapper;
